export default __webpack_public_path__ + "0f356f01e754be95deed2166f8ffee67.svg";